import { styled } from '@mui/material/styles';
import { default as BaseLanguageSelector } from './../LanguageSelector';

export const LanguageSelector = styled(BaseLanguageSelector)(({ theme }) => ({
  borderRadius: `0 ${theme.borderRadius.base} ${theme.borderRadius.base} 0`
}));
